import dayjs from 'dayjs';
import * as yup from 'yup';

/*
The validation rules are:
# Single row
 - requestDate is not required 
 - Completely empty row is allowed.
# Multiple rows
 - requestDate is required for every row, regardless of time.
*/

// Message is sent from json schema
const DispatchCreateServiceRequestValidation = (
  messageFromSchema,
  formatMessageFn,
) =>
  yup
    .object({
      requestDate: yup.string().nullable(),
      slotTypeCode: yup.string().nullable(),
    })
    .test(
      'dispatch-date-conditional',
      formatMessageFn(messageFromSchema),
      function rowTest(value) {
        const rowCount = this.options?.context?.rowCount ?? 1;

        if (!value) return true;

        const { requestDate } = value;

        // Single row
        if (rowCount === 1) {
          if (!requestDate) {
            return this.createError({
              path: `${this.path}.requestDate`,
              message: formatMessageFn(messageFromSchema),
            });
          }
          return true;
        }

        // Multiple rows → every row needs date
        if (!requestDate && rowCount > 1) {
          return this.createError({
            path: `${this.path}.requestDate`,
            message: formatMessageFn(messageFromSchema),
          });
        }

        if (dayjs(requestDate).isBefore(dayjs(), 'day')) {
          return this.createError({
            path: `${this.path}.requestDate`,
            message: formatMessageFn({
              id: 'DATE_CANNOT_BE_IN_THE_PAST',
              defaultMessage: 'Date cannot be in the past',
            }),
          });
        }

        return true;
      },
    );

export default DispatchCreateServiceRequestValidation;
